<div class="wizard">
  <div class="wizard-menu">
    <div class="wizard-menu-logo-wrapper">
      <div class="wizard-menu-logo">
        <img mat-card-image src="{{themeManager.getWhiteLogo()}}" />
        <span class="wizard-menu-logo-text">{{wizardTitle}}</span>
      </div>
    </div>
    <div class="wizard-menu-items-wrapper">
    <ng-container *ngFor="let menuItem of menuItems">
      <div *ngIf="!menuItem.hide && (!isDivider(menuItem) && !isSubmenu(menuItem))" class="menu-item-wrapper" [class.selected]="menuItem.selected" (click)="menuClick(menuItem)">
        {{menuItem.description}}
        <mat-icon [svgIcon]="menuItem.svgIcon" [class]="menuItem.matIconClass">{{menuItem.matIcon}}</mat-icon>
      </div>
      <div *ngIf="!menuItem.hide && isDivider(menuItem)" class="menu-item-divider">
      </div>
      <div *ngIf="!menuItem.hide && isSubmenu(menuItem)" class="menu-item-submenu" [class.selected]="menuItem.selected">
        <div class="menu-item-wrapper" [class.selected]="menuItem.selected" (click)="menuClick(menuItem)">
          {{menuItem.description}}
          <mat-icon [svgIcon]="menuItem.svgIcon" [fontSet]="menuItem.matFontSet" [ngStyle]="menuItem.matStyle">{{menuItem.matIcon}}</mat-icon>
        </div>
        <div class="menu-item-submenu-wrapper">
          <ng-container *ngFor="let subMenuItem of menuItem.menuItems">
            <div *ngIf="!subMenuItem.hide" class="submenu-item-wrapper" [class.selected]="subMenuItem.selected" (click)="menuClick(subMenuItem)">
                {{subMenuItem.description}}
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    </div>
    
    <ng-content select="[mat-button], [mat-raised-button], [mat-icon-button]"></ng-content>
  </div>
  <div class="wizard-content">
    <cw-dialog #dialog [title]='title' [subTitle]='subTitle' [showCloseButton]="true" [showLogo]="false" (eventHandler)="onEvent($event)" class="no-border">
      <div class="custom-header-action">
        <ng-container [ngTemplateOutlet]="customHeaderAction"></ng-container>
      </div>

      <ng-container [ngTemplateOutlet]="content"></ng-container>

      <button *ngIf="displayButtons" mat-button type="button" color="primary" (click)="onEvent({ state: 'CANCEL' })">Cancel</button>
      <button [disabled]="currentScreen?.component.isPreviousButtonDisabled()" *ngIf="displayButtons && autoAdvance && hasPrevScreen()" mat-raised-button type="button" color="primary" (click)="onEvent({ state: 'PREVIOUS' })">Prev</button>
      <button [disabled]="currentScreen?.component.isSaveButtonDisabled()" *ngIf="displayButtons" mat-raised-button type="button" color="primary" (click)="onEvent({ state: 'SAVE' })">{{nextButtonText}}</button>
    </cw-dialog>
  </div>
</div>